module.exports = __webpack_public_path__ + "img/step6.a92d68a9.svg";